import { Link } from 'react-router-dom';
import { articles, categories } from '@/mocks/articles';
import ArticleCard from '@/components/base/ArticleCard';

export default function HotWorks() {
  const hotArticles = articles.filter((a) => a.hot).slice(0, 8);

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-8 md:mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              热门作品
            </h2>
            <p className="mt-2 text-sm md:text-base text-foreground-600">
              全站最受欢迎的同人佳作
            </p>
          </div>
          <Link
            to="/category/comic"
            className="hidden sm:flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看更多
            <i className="ri-arrow-right-line text-base w-4 flex items-center justify-center"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {hotArticles.map((article) => (
            <ArticleCard
              key={article.id}
              {...article}
              categoryName={categories.find((c) => c.slug === article.category)?.name || article.category}
            />
          ))}
        </div>
      </div>
    </section>
  );
}